import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'
import TokenIndicator from './TokenIndicator'
import ListSubheader from '@mui/material/ListSubheader'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'

interface Props {
  selected?: Token
  tokens: Token[]
  networks: NetworkRecord[]
  disabled?: boolean
  tabIndex?: number
  onSelect: (token: Token) => void
}

export default function TokenSelect({ selected, onSelect, tokens, networks, disabled, tabIndex }: Props) {
  const selectedNetwork = networks.find(n => n.id === selected?.networkId)

  return (
    selected && (
      <TextField
        select
        fullWidth
        disabled={disabled}
        label="Network"
        value={selected.id}
        slotProps={{
          htmlInput: {
            tabIndex,
          },
          select: {
            renderValue: () => (
              <>
                <Typography variant="subtitle2">{selectedNetwork?.name}</Typography>
                <Typography>
                  {selected.name} <TokenIndicator token={selected} />
                </Typography>
              </>
            ),
          },
        }}
        sx={{ marginBottom: 2 }}
      >
        {networks.map((network, index) => {
          const networkTokens = tokens.filter(token => token.networkId === network.id)
          if (networkTokens.length === 0) return null
          return [
            !!index && <Divider />,
            <ListSubheader>{network.name}</ListSubheader>,
            networkTokens.map(nt => (
              <MenuItem key={nt.id} value={nt.id} onClick={() => onSelect?.(nt)}>
                {nt.name} <TokenIndicator token={nt} />
              </MenuItem>
            )),
          ]
        })}
      </TextField>
    )
  )
}
